import { Component, OnInit, Input } from '@angular/core';
import { CONSTANTS } from '../../constants';

@Component({
  selector: 'app-premiit-chip',
  templateUrl: './premiit-chip.component.html',
  styleUrls: ['./premiit-chip.component.scss']
})
export class PremiitChipComponent implements OnInit {
  @Input() chipHeight: number;
  @Input() chipWidth: number;
  @Input() logoHeight: number;
  @Input() logoWidth: number;

  constructor() {
    this.chipHeight = CONSTANTS.defaultChipHeight;
    this.chipWidth = CONSTANTS.defaultChipWidth;
    this.logoHeight = CONSTANTS.defaultLogoHeight;
    this.logoWidth = CONSTANTS.defaultLogoWidth;
  }

  ngOnInit(): void {
  }

}
